module.exports = __webpack_public_path__ + "img/loader.b955c6f3.gif";